module.exports = __webpack_public_path__ + "img/solution11.5258004f.jpg";